import { debounceTime } from 'rxjs';

import { Component } from '@angular/core';
import { KeyboardFacade } from '@ideapa/app-keyboard';
import { NavigationFacade } from '@ideapa/app-navigation';
import { NgrxLoaderFacade } from '@ideapa/app-ngrx-loader';

@Component({
  standalone: false,
  selector: 'ideapa-software-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    private loaderFacade: NgrxLoaderFacade,
    private navigationFacade: NavigationFacade,
    private keyboardFacade: KeyboardFacade
  ) {}

  isLoaderVisible$ = this.loaderFacade.isLoaderVisible$.pipe(debounceTime(250));

  activeTab$ = this.navigationFacade.activeTab$;

  showHelp$ = this.keyboardFacade.showHelp$;
}
